<!-- Department header -->
<app-dept-header *ngIf="deptId != undefined"></app-dept-header>
<!-- Department header -->
<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-12">
        <div id="page-main">
          <section id="members">


            <!--CSS Loader-->
            <section *ngIf="loader">
              <h3 class="no-divider"></h3>
              <div class="row">
                <div class="col-md-6 col-sm-6" *ngFor="let x of divRepat">
                  <div class="ph-item author-block course-speaker ph-border">
                    <div class="ph-col-4">
                      <div class="ph-avatar"></div>
                    </div>
                    <article class="paragraph-wrapper">
                      <div class="ph-row inner">
                        <div class="ph-col-12 empty"></div>
                        <div class="ph-col-12 empty"></div>
                        <div class="ph-col-8"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-12"></div>
                        <div class="ph-col-8"></div>
                        <div class="ph-col-6"></div>
                        <div class="ph-col-4"></div>
                      </div>
                    </article>
                  </div>
                </div><!-- /.author -->
              </div> <!-- /.row -->
            </section><!-- /#our-speakers -->
            <!--CSS Loader-->


            <section id="our-staff" *ngFor="let member of deptStaffData">
              <header>
                <h3 class="no-divider" *ngIf="member.staff.length != 0">{{member.category}}</h3>
              </header>

              <div class="row">
                <div class="col-md-6 col-sm-6" *ngFor="let member of member.staff">
                  <div class="author-block course-speaker">
                    <a routerLink="/staff/{{member.profile_name}}/{{deptId}}">
                      <figure class="author-picture">
                        <span *ngIf="member.user?.profile_image != 'null'">
                          <img src="{{member.user?.profile_image}}" alt="{{member.profile_name}}">
                        </span>
                      </figure>

                    </a>
                  <article class="paragraph-wrapper">
                    <div class="inner">
                      <header>
                        <a routerLink="/staff/{{member.profile_name}}/{{deptId}}">
                          {{member.full_name}} ({{member.title}}.)
                        </a>
                      </header>
                      <div *ngFor="let desig of member.designations">
                        <p>{{desig.designation}}</p>
                      </div>

                        <span class="desitination-staff" *ngIf="member.qualification.length != 0">{{member.qualification[0].description}}</span>

                      <p>
                      <span *ngIf="member.user.email != 'null'">
                            {{member.user.email}}
                      </span>

                      <span *ngIf="member.contact != 'null'">
                            <br>{{member.contact}}
                      </span>
                    </p>
                      <a routerLink="/staff/{{member.profile_name}}/{{deptId}}" class="btn-link linked-button">
                        Profile
                      </a>
                    </div>
                  </article>
                </div>
                </div><!-- /.author -->

              </div> <!-- /.row -->
            </section><!-- /#our-speakers -->

          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
